import React from "react";
import { MdLocalShipping, MdOutlineAssignmentReturn } from "react-icons/md";
import { showZoneTime, formatDate } from "../../Helpers/Utils";
import { Skeleton } from "../../Components/Needed";

const STATUS_ORDER = ["pending", "assigned", "progress", "completed", "cancel"];

const TaskQueue = ({ tasks, loading }) => {
    if (loading) {
        return (
            <div>
                {[0, 1, 2].map((i) => <Skeleton key={i} height={40} className="mb-2" />)}
            </div>
        );
    }

    const byStatus = tasks?.byStatus || {};
    const queue = tasks?.queue || [];

    return (
        <div>
            <div className="d-flex flex-wrap gap-2 mb-3">
                {STATUS_ORDER.map((status) => (
                    <span key={status} className={`task-status-pill ${status}`}>
                        {status}: {Number(byStatus[status] || 0)}
                    </span>
                ))}
            </div>

            {queue.length ? (
                queue.map((task) => (
                    <div className="task-queue-item" key={task.taskId}>
                        <span className={`task-type-badge ${task.taskType === "Pickup" ? "is-pickup" : ""}`}>
                            {task.taskType === "Pickup" ? <MdOutlineAssignmentReturn /> : <MdLocalShipping />}
                        </span>
                        <div className="task-queue-main">
                            <div className="task-queue-title">{task.taskType} - {task.bookingId}</div>
                            <div className="task-queue-meta">
                                {formatDate(task.taskTime)} {showZoneTime(task.taskTime)}
                                {task.staffId ? ` - ${task.staffId}` : " - unassigned"}
                            </div>
                        </div>
                        <span className={`task-status-pill ${task.status}`}>{task.status}</span>
                    </div>
                ))
            ) : (
                <div className="mini-table-empty">No open delivery/pickup tasks.</div>
            )}
        </div>
    );
};

export default TaskQueue;
